<dialog #dialog class="modal">
  <div class="modal-box flex flex-col gap-4">
    <h3 class="text-lg font-bold">{{ 'RESET_PASSWORD' | translate }}</h3>

    <form [formGroup]="form" class="flex flex-col gap-4">

      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium">{{ 'CURRENT_PASSWORD' | translate }}</span>
        <div class="relative">
          <input [type]="hideCurrent ? 'password' : 'text'" formControlName="currentPassword"
                 class="input w-full pr-10">
          <button type="button" class="absolute right-2 top-1/2 -translate-y-1/2 btn btn-ghost btn-xs btn-circle"
                  (click)="hideCurrent = !hideCurrent">
            <span class="material-icons-outlined text-sm">{{ hideCurrent ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </div>
      </div>

      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium">{{ 'NEW_PASSWORD' | translate }}</span>
        <div class="relative">
          <input [type]="hideNew ? 'password' : 'text'" formControlName="newPassword"
                 class="input w-full pr-10" (keydown)="preventSpaces($event)">
          <button type="button" class="absolute right-2 top-1/2 -translate-y-1/2 btn btn-ghost btn-xs btn-circle"
                  (click)="hideNew = !hideNew">
            <span class="material-icons-outlined text-sm">{{ hideNew ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </div>
      </div>

      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium">{{ 'CONFIRM_PASSWORD' | translate }}</span>
        <div class="relative">
          <input [type]="hideConfirm ? 'password' : 'text'" formControlName="confirmPassword"
                 class="input w-full pr-10" (keydown)="preventSpaces($event)">
          <button type="button" class="absolute right-2 top-1/2 -translate-y-1/2 btn btn-ghost btn-xs btn-circle"
                  (click)="hideConfirm = !hideConfirm">
            <span class="material-icons-outlined text-sm">{{ hideConfirm ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </div>
      </div>

      @if (form.hasError('mismatch')) {
        <p class="text-error text-sm">{{ 'PASSWORD_MATCH_ERROR' | translate }}</p>
      }
      @if (form.hasError('minlength')) {
        <p class="text-error text-sm">{{ 'PASSWORD_LENGTH_ERROR' | translate:{ minLength: minPasswordLength } }}</p>
      }
      @if (form.get('newPassword')?.hasError('complexity')) {
        <p class="text-error text-sm">{{ 'PASSWORD_COMPLEXITY_ERROR' | translate }}</p>
      }

    </form>

    <div class="modal-action">
      <button class="btn btn-ghost" (click)="onCancel()">{{ 'CANCEL_DIALOG_CONF' | translate }}</button>
      <button class="btn btn-primary" (click)="onSave()" [disabled]="form.invalid">{{ 'SUBMIT' | translate }}</button>
    </div>
  </div>
  <form method="dialog" class="modal-backdrop">
    <button (click)="onCancel()">close</button>
  </form>
</dialog>
